<app-report reportId="NrSummary" screen="NRSUM" [submenu]="true"></app-report>
